// import { Button } from "../../ui/button";

import { useParams } from "react-router-dom";
import React from "react";
import Spinner from "../../../../components/spinner.components";
import type { IBrand } from "../../../../types/models/brands.models.types";
import { useGetBrandByIdAdminHttp } from "../../../../hooks/http/admin/brands/get-brand-by-id.admin.http";
import { useToast } from "../../../../hooks/use-toast";
import { handleHttpError } from "../../../../utils/utils";

export const BrandInfoSliderMenuPartial: React.FunctionComponent = () => {
	const { brandId } = useParams();
	const [data, setData] = React.useState<IBrand>();

	const { execute: getBrandByIdHttp, fetching } = useGetBrandByIdAdminHttp();

	const { toast } = useToast();

	async function getBrand() {
		if (brandId) {
			const response = await getBrandByIdHttp({
				body: null,
				pathParams: { id: brandId },
			});

			if (!response.success) {
				return handleHttpError(response, toast);
			}
			setData(response.data.brand);
		}
	}

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	React.useEffect(() => {
		getBrand();
	}, [brandId]);

	return fetching ? (
		<div className="flex justify-center items-center w-full h-full">
			<Spinner width={30} />
		</div>
	) : (
		<div className="flex flex-col gap-10 w-full h-full">
			<div className="flex flex-col w-full">
				<div className="flex flex-col gap-8 py-5 pb-10 pl-5 border-b border-border w-full">
					<div className="flex items-center gap-6">
						<img
							src="/static/profile.png"
							className="rounded-xl w-20 h-20"
							alt=""
						/>
						<div className="flex flex-col justify-between gap-1">
							<p className="font-semibold text-3xl">{data?.name} </p>

							<div className="flex items-center gap-2 font-semibold text-xl">
								<span className="text-secondary text-sm">Account owner :</span>
								Mukesh Ambani
							</div>
						</div>
					</div>
					<div className="flex justify-between items-center max-w-lg">
						<div className="flex flex-col">
							<span className="text-lg text-secondary">
								Account owner email
							</span>
							<p className="text-xl">admin@jiocinema.in</p>
						</div>
						<div className="border border-border h-full" />
						<div className="flex flex-col">
							<span className="text-lg text-secondary">
								Account owner Mobile
							</span>
							<p className="text-xl">+91-80001 10008</p>
						</div>
					</div>
				</div>
				<div className="flex flex-col gap-8 py-10 pl-5 border-b border-border w-full">
					<p className="text-xl">Brand overview</p>
					<div className="flex flex-col gap-4">
						<div className="flex justify-between items-center">
							<div className="flex flex-col flex-1 text-start">
								<span className="text-lg text-secondary">Total campaigns</span>
								<p className="flex items-center gap-2 font-black text-xl">
									50 campaigns
								</p>
							</div>
							<div className="border border-border h-full" />

							<div className="flex flex-col flex-1 pl-16 text-start">
								<span className="text-lg text-secondary">
									Total spending on solo
								</span>
								<p className="flex items-center gap-2 font-black text-xl">
									₹ 4,00,000
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
